var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4902_29079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2734 74.4141C88.9324 75.1109 87.5496 75.7241 86.1328 76.25C81.6467 77.9198 76.8961 78.7667 72.1094 78.75C53.6328 78.75 37.5391 66.0547 37.5391 49.7266C37.5631 47.5402 38.1693 45.3996 39.2952 43.5253C40.4212 41.651 42.0263 40.1105 43.9453 39.0625C27.2266 39.7656 22.9297 57.1875 22.9297 67.3828C22.9297 96.2891 49.5313 99.1797 55.2734 99.1797C58.3594 99.1797 63.0078 98.2812 65.8203 97.3828L66.3281 97.2266C77.0914 93.5069 86.267 86.2326 92.3438 76.6016C92.5204 76.3089 92.5961 75.9665 92.5595 75.6266C92.5229 75.2868 92.3758 74.9684 92.1408 74.7201C91.9059 74.4719 91.596 74.3076 91.2587 74.2523C90.9214 74.197 90.5753 74.2538 90.2734 74.4141Z",
    fill: "url(#paint0_linear_4902_29079)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M90.2734 74.4141C88.9324 75.1109 87.5496 75.7241 86.1328 76.25C81.6467 77.9198 76.8961 78.7667 72.1094 78.75C53.6328 78.75 37.5391 66.0547 37.5391 49.7266C37.5631 47.5402 38.1693 45.3996 39.2952 43.5253C40.4212 41.651 42.0263 40.1105 43.9453 39.0625C27.2266 39.7656 22.9297 57.1875 22.9297 67.3828C22.9297 96.2891 49.5313 99.1797 55.2734 99.1797C58.3594 99.1797 63.0078 98.2812 65.8203 97.3828L66.3281 97.2266C77.0914 93.5069 86.267 86.2326 92.3438 76.6016C92.5204 76.3089 92.5961 75.9665 92.5595 75.6266C92.5229 75.2868 92.3758 74.9684 92.1408 74.7201C91.9059 74.4719 91.596 74.3076 91.2587 74.2523C90.9214 74.197 90.5753 74.2538 90.2734 74.4141Z",
    fill: "url(#paint1_radial_4902_29079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2892 94.2578C37.8122 92.0983 34.7982 89.2702 32.422 85.9375C29.7085 82.2234 27.8406 77.9605 26.9495 73.4478C26.0585 68.9352 26.1657 64.2823 27.2638 59.8155C28.3619 55.3488 30.4242 51.1764 33.306 47.5913C36.1877 44.0062 39.8192 41.0952 43.9454 39.0625C45.1954 38.4766 47.2657 37.4609 50.0392 37.5C51.9908 37.5151 53.9125 37.9813 55.654 38.8623C57.3955 39.7432 58.9097 41.015 60.0782 42.5781C61.65 44.6917 62.5115 47.249 62.5392 49.8828C62.5392 49.8047 72.1095 18.7891 31.2892 18.7891C14.1407 18.7891 0.0391839 35.0391 0.0391839 49.3359C-0.029025 56.8881 1.58558 64.3607 4.76575 71.2109C9.97384 82.3009 19.0725 91.0926 30.3346 95.9172C41.5967 100.742 54.2383 101.263 65.8595 97.3828C61.7881 98.6687 57.486 99.0552 53.2505 98.5157C49.0151 97.9761 44.9473 96.5234 41.3282 94.2578H41.2892Z",
    fill: "url(#paint2_linear_4902_29079)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M41.2892 94.2578C37.8122 92.0983 34.7982 89.2702 32.422 85.9375C29.7085 82.2234 27.8406 77.9605 26.9495 73.4478C26.0585 68.9352 26.1657 64.2823 27.2638 59.8155C28.3619 55.3488 30.4242 51.1764 33.306 47.5913C36.1877 44.0062 39.8192 41.0952 43.9454 39.0625C45.1954 38.4766 47.2657 37.4609 50.0392 37.5C51.9908 37.5151 53.9125 37.9813 55.654 38.8623C57.3955 39.7432 58.9097 41.015 60.0782 42.5781C61.65 44.6917 62.5115 47.249 62.5392 49.8828C62.5392 49.8047 72.1095 18.7891 31.2892 18.7891C14.1407 18.7891 0.0391839 35.0391 0.0391839 49.3359C-0.029025 56.8881 1.58558 64.3607 4.76575 71.2109C9.97384 82.3009 19.0725 91.0926 30.3346 95.9172C41.5967 100.742 54.2383 101.263 65.8595 97.3828C61.7881 98.6687 57.486 99.0552 53.2505 98.5157C49.0151 97.9761 44.9473 96.5234 41.3282 94.2578H41.2892Z",
    fill: "url(#paint3_radial_4902_29079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5312 58.125C59.1797 58.5156 58.2031 59.1016 58.2031 60.3125C58.2031 61.3281 58.8672 62.3438 60.0781 63.1641C65.6641 67.0703 76.25 66.5234 76.2891 66.5234C80.4533 66.5207 84.5406 65.4011 88.125 63.2812C91.7336 61.1705 94.7278 58.1533 96.8108 54.5286C98.8938 50.9039 99.9932 46.7977 100 42.6172C100.117 33.8672 96.875 28.0469 95.5859 25.4687C87.2656 9.29687 69.4141 2.44782e-07 50 2.44782e-07C36.8601 -0.00129905 24.2478 5.16992 14.8909 14.3952C5.53408 23.6205 0.18478 36.1583 0 49.2969C0.195312 35.0391 14.375 23.5156 31.25 23.5156C32.6172 23.5156 40.4297 23.6328 47.6562 27.4219C52.7332 29.9447 56.9376 33.9314 59.7266 38.8672C62.1094 43.0078 62.5391 48.2812 62.5391 50.3906C62.5391 52.5 61.4844 55.5859 59.4922 58.1641L59.5312 58.125Z",
    fill: "url(#paint4_radial_4902_29079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5312 58.125C59.1797 58.5156 58.2031 59.1016 58.2031 60.3125C58.2031 61.3281 58.8672 62.3438 60.0781 63.1641C65.6641 67.0703 76.25 66.5234 76.2891 66.5234C80.4533 66.5207 84.5406 65.4011 88.125 63.2812C91.7336 61.1705 94.7278 58.1533 96.8108 54.5286C98.8938 50.9039 99.9932 46.7977 100 42.6172C100.117 33.8672 96.875 28.0469 95.5859 25.4687C87.2656 9.29687 69.4141 2.44782e-07 50 2.44782e-07C36.8601 -0.00129905 24.2478 5.16992 14.8909 14.3952C5.53408 23.6205 0.18478 36.1583 0 49.2969C0.195312 35.0391 14.375 23.5156 31.25 23.5156C32.6172 23.5156 40.4297 23.6328 47.6562 27.4219C52.7332 29.9447 56.9376 33.9314 59.7266 38.8672C62.1094 43.0078 62.5391 48.2812 62.5391 50.3906C62.5391 52.5 61.4844 55.5859 59.4922 58.1641L59.5312 58.125Z",
    fill: "url(#paint5_radial_4902_29079)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4902_29079",
    x1: 22.9297,
    y1: 69.1406,
    x2: 92.6172,
    y2: 69.1406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4902_29079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4063 69.666) scale(37.2656 35.4023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4902_29079",
    x1: 59.6486,
    y1: 38.9062,
    x2: 16.172,
    y2: 86.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4902_29079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5607 77.7098) rotate(-81.3844) scale(56.0102 45.2506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4902_29079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1133 18.4828) rotate(92.2906) scale(79.1257 168.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4902_29079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.7734 30.1953) rotate(73.7398) scale(38.0078 30.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4902_29079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdge);
export default __webpack_public_path__ + "static/media/ic_edge.a6dc2b71fe428125b55e620a566e6195.svg";
export { ForwardRef as ReactComponent };